export const initialComicPageState = {
    result:1,
    lastValues: [],
    comicCover: "http://i.annihil.us/u/prod/marvel/i/mg/9/b0/4c7d666c0e58a.jpg",
    comicTitle:"hey now im the Title",
    comicDescription:"this is the descrition of the comic to start with. It will be changed using a reducer function()",
    characters:[],
    creators:[],
    comicID:1689
}
//set the state to initialState here, only if nothing is passed
//the reducers hold the current state of whatever object you pass them. in this case 'initialComicPageState' 
export const comicPageReducer = (state = initialComicPageState,action) => {
    switch(action.type){
        case "CHANGE-MAIN-COMIC":
            state = {
                ...state,//this will grab everything from the previous state
                comicCover: action.payload[2],
                comicTitle: action.payload[0],
                comicDescription: action.payload[1],
                creators: action.payload[7],
                comicID: action.payload[3]
            };

            case "CHANGE-CHARACTERS-IN-COMIC":
            state = {
                ...state,//this will grab everything from the previous state
                characters: action.payload
            };


    }
    //reducers always have to return some sort of state
    return state;
};



// WEBPACK FOOTER //
// ./src/reducers/comicPageReducer.js